import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Button } from 'semantic-ui-react'

import AppUtils from '../../utils/AppUtils'
import AppConstants from '../../utils/AppConstants'
import ColumnsProvider from '../../utils/ColumnsProvider'
import Page from '../../components/elements/Page'
import Header from '../../components/elements/Header'
import Table from '../../components/elements/Table'
import Confirm from '../../components/elements/Confirm'
import CreateMaintenancePopup from '../popups/maintenances/CreateMaintenancePopup'
import UpdateMaintenancePopup from '../popups/maintenances/UpdateMaintenancePopup'
import Grant from '../elements/Grant'

import Types from '../../actions/Types'
import ListAction from '../../actions/maintenances/ListAction'
import DeleteAction from '../../actions/maintenances/DeleteAction'
import ChangePageAction from '../../actions/app/ChangePageAction'
import ClearErrorAction from '../../actions/app/ClearErrorAction'

class MaintenanceListPage extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      isCreate: false,
      updateId: null,
      deleteId: null
    }

    // Bind events
    this.onClickSelect = this.onClickSelect.bind(this)
    this.onClickCreate = this.onClickCreate.bind(this)
    this.onCloseCreate = this.onCloseCreate.bind(this)
    this.onClickUpdate = this.onClickUpdate.bind(this)
    this.onCloseUpdate = this.onCloseUpdate.bind(this)
    this.onClickDelete = this.onClickDelete.bind(this)
    this.onConfirmDelete = this.onConfirmDelete.bind(this)
  }

  componentDidMount() {
    this.props.fetch()
  }

  componentDidUpdate(prevProps, prevState) {
    // After a maintenance has been deleted, refresh
    if (
      prevProps.deleteIsFetching
      &&
      !this.props.deleteIsFetching
    ) {
      this.setState({
        deleteId: null
      })
      AppUtils.setStatus(
        this.props.deleteError
          ? AppConstants.STATUS.TYPE.FAILURE
          : AppConstants.STATUS.TYPE.SUCCESS,
        this.props.deleteError
          ? AppUtils.errorToText(this.props.deleteError, {
              [AppConstants.ERROR.BAD_REQUEST.RESOURCE_IN_USE]: 'Cette maintenance a déjà été exécutée.'
            })
          : 'Maintenance supprimée.'
      )
      if (!this.props.deleteError) {
        this.props.fetch()
      }
    }
  }

  onClickSelect(id) {
    return () => {
      this.props.changePage(AppConstants.PAGE.MAINTENANCE_VIEW, id)
    }
  }

  onClickCreate() {
    this.setState({
      isCreate: true
    })
  }

  onCloseCreate(isDirty) {
    this.setState({
      isCreate: false
    })
    if (isDirty) {
      this.props.fetch()
    }
  }

  onClickUpdate(id) {
    return () => {
      this.setState({
        updateId: id
      })
    }
  }

  onCloseUpdate(isDirty) {
    this.setState({
      updateId: null
    })
    if (isDirty) {
      this.props.fetch()
    }
  }

  onClickDelete(id) {
    return () => {
      this.setState({
        deleteId: id
      })
    }
  }

  onConfirmDelete(proceed) {
    if (proceed) {
      this.props.delete(this.state.deleteId)
    }
    else {
      this.setState({
        deleteId: null
      })
    }
  }

  render() {
    return (
      <React.Fragment>
        <Page direction={Page.DIRECTION.ROW}>
          <Page.Element
            flex='1 1 100%'
            style={{
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Header
              style={{
                flex: '0 0 auto'
              }}
              title='Maintenances'
              right={
                <Grant role={Grant.ROLE.MANAGE}>
                  <Button
                    compact={true}
                    icon='plus'
                    content='Créer'
                    color='green'
                    onClick={this.onClickCreate}
                  />
                </Grant>
              }
            />
            <Table
              columns={[
                // Matériel
                ColumnsProvider.maintenanceProduct,
                // Nom
                ColumnsProvider.maintenanceNameBasic,
                // Tous les
                ColumnsProvider.maintenancePeriodicity,
                // Effectuée par
                ColumnsProvider.maintenanceOutside,
                // Prochaine
                ColumnsProvider.maintenanceNextWithDetails(true),
                // Actions
                ColumnsProvider.maintenanceActions(
                  this.onClickUpdate,
                  this.onClickDelete,
                  this.onClickSelect
                )
              ]}
              data={this.props.list}
              error={this.props.error}
              isLoading={this.props.isFetching}
              emptyMessage="Il n'existe aucune maintenance pour le moment."
            />
          </Page.Element>
        </Page>
        {
          this.state.isCreate
            ? <CreateMaintenancePopup
                onClose={this.onCloseCreate}
              />
            : null
        }
        {
          !_.isNull(this.state.updateId)
            ? <UpdateMaintenancePopup
                id={this.state.updateId}
                onClose={this.onCloseUpdate}
              />
            : null
        }
        {
          !_.isNull(this.state.deleteId)
            ? <Confirm
                header="Suppression d'une maintenance"
                body="Êtes-vous sûr de vouloir supprimer cette maintenance ?"
                confirmText='Supprimer'
                confirmColor='red'
                confirmIcon='trash'
                isProceeding={this.props.deleteIsFetching}
                callback={this.onConfirmDelete}
              />
            : null
        }
      </React.Fragment>
    )
  }
}

MaintenanceListPage.propTypes = {
  // Properties

  // Redux State
  list: PropTypes.array,
  isFetching: PropTypes.bool.isRequired,
  error: PropTypes.object,
  deleteIsFetching: PropTypes.bool.isRequired,
  deleteError: PropTypes.object,

  // Redux Actions
  fetch: PropTypes.func.isRequired,
  delete: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired,
  changePage: PropTypes.func.isRequired
}

export default connect(
  (state) => ({
    list: state.entities.maintenances.list.data,
    isFetching: state.entities.maintenances.list.isFetching,
    error: state.entities.maintenances.list.error,
    deleteIsFetching: state.entities.maintenances.delete.isFetching,
    deleteError: state.entities.maintenances.delete.error
  }),
  (dispatch) => ({
    fetch: () => (dispatch(ListAction({}))),
    delete: (id) => (dispatch(DeleteAction({ id }))),
    clearError: () => (dispatch(ClearErrorAction(Types.MAINTENANCES.LIST))),
    changePage: (page, id) => (dispatch(ChangePageAction(page, { id })))
  })
)(MaintenanceListPage)



// WEBPACK FOOTER //
// ./src/containers/pages/MaintenanceListPage.js